// components/ReporteGeneral.tsx
import React, { useEffect, useState } from 'react';
import {
    Box,
    SimpleGrid
} from '@chakra-ui/react';
import FechaRangoPicker from 'components/fecharangopicker';
import { useDispatch, useSelector } from 'react-redux';
import { getReporteGeneral } from 'store/features/slices/reporteSlice';
import { currencyFormat } from 'utils/Funciones';
import { uriSerialized } from 'utils/uriSerialized';
import Loader from 'components/loader/Loader';
import Widget from 'components/widget/Widget';
import { IoBagHandleOutline, IoCartOutline, IoCashOutline, IoPricetagOutline, IoStatsChartOutline, IoTrendingUpOutline } from 'react-icons/io5';
import Spinner from 'components/spinner/Spinner';

const ReporteGeneral = () => {
    const dispatch = useDispatch();
    const [filtroFechas, setFiltroFechas] = useState({ fechaInicio: '', fechaFin: '' });
    const {
        reporteGeneral,
        isLoading,
    } = useSelector((state) => state.reporteReducer);

    useEffect(() => {
        const fetchReporte = async () => {
            try {
                const { fechaInicio, fechaFin } = filtroFechas;

                if (!fechaInicio && fechaFin) {
                    setFiltroFechas((prev) => ({ ...prev, fechaFin: "" }));
                    return;
                }
                const fechasSonValidas =
                    (!fechaInicio && !fechaFin) || (fechaInicio && fechaFin);

                if (!fechasSonValidas) return;

                const queryOptions = {
                    search: {
                        fechaInicio: fechaInicio || "",
                        fechaFin: fechaFin || ""
                    }
                };
                const query = "?" + uriSerialized(queryOptions);
                dispatch(getReporteGeneral({ query }));
            } catch (err) {
                console.error(err);
            }
        };

        fetchReporte();
    }, [filtroFechas]);

    return (
        <Box className="relative px-4 py-8 rounded-xl shadow-md bg-white dark:bg-navy-700">
            <div className="w-full md:w-6/12">
                <FechaRangoPicker
                    fechaInicio={filtroFechas.fechaInicio}
                    fechaFin={filtroFechas.fechaFin}
                    onChange={(value) => setFiltroFechas(prev => ({ ...prev, ...value }))}
                />
            </div>
            <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={{ base: 3, md: 4, lg: 5 }} mt={5}>
                <Widget
                    icon={<IoCartOutline className="h-7 w-7 text-blue-500 dark:text-blue-300" />}
                    title={"Total de Ventas"}
                    subtitle={isLoading ? <Spinner /> : reporteGeneral?.totalVentas || 0}
                />
                <Widget
                    icon={<IoCashOutline className="h-7 w-7 text-green-500 dark:text-green-300" />}
                    title={"Total Ingresos"}
                    subtitle={isLoading ? <Spinner /> : currencyFormat(reporteGeneral?.totalIngresos || 0)}
                />
                <Widget
                    icon={<IoBagHandleOutline className="h-7 w-7 text-purple-500 dark:text-purple-300" />}
                    title={"Productos Vendidos"}
                    subtitle={isLoading ? <Spinner /> : reporteGeneral?.totalProductos || 0}
                />
                <Widget
                    icon={<IoTrendingUpOutline className="h-7 w-7 text-yellow-500 dark:text-yellow-300" />}
                    title={"Venta Promedio"}
                    subtitle={isLoading ? <Spinner /> : currencyFormat(reporteGeneral?.ventaPromedio || 0)}
                />
                <Widget
                    icon={<IoPricetagOutline className="h-7 w-7 text-yellow-500 dark:text-yellow-300" />}
                    title={"Total descuentos"}
                    subtitle={isLoading ? <Spinner /> : currencyFormat(reporteGeneral?.totalDescuentos || 0)}
                />
                <Widget
                    icon={<IoStatsChartOutline className="h-7 w-7 text-rose-500 dark:text-rose-300" />}
                    title={"Total de Ganancias"}
                    subtitle={isLoading ? <Spinner /> : currencyFormat(reporteGeneral?.totalGanancias || 0)}
                />
            </SimpleGrid>
            {isLoading && <Loader color="#64707d" className="mt-4" />}
        </Box>
    );
};

export default ReporteGeneral;
